export default [
    {
        path: '/pue',
        component : () => import('@/views/pue/main'),
        children:[
            {
                path:'/',
                component : () => import('@/views/pue/report/main')
            },
            {
                path:'report',
                component : () => import('@/views/pue/report/main')
            },
            {
                path:'report/pointInTime',
                component : () => import('@/views/pue/report/pue.pointInTime.main')
            },
            {
                path: 'daily',
                component: () => import('@/views/pue/daily/pue.daily.main'),
                children: [
                    {
                        path: 'list',
                        components: {
                            list: () => import('@/views/pue/daily/pue.daily.list'),
                        },
                    },
                    {
                        path: 'detail',
                        components: {
                            detail: () => import('@/views/pue/daily/pue.daily.detail'),
                        },
                    }
                ]
            },
        ]
    },
];